/* PRJKT8 strap try-on. Opens from a watch or strap page (a sheet over the page) or fills the try-on page.
   Settings come from snippet p8-strap-tryon (window.P8T); fit data and pictures are theme files. */
(function () {
  'use strict';
  if (window.P8Tryon) return;
  var C = window.P8T || {};
  var AR = C.lang === 'ar';
  // Add to bag is off while The Strap Room is in beta (17 Oct 2026): an in-stock strap asks the client to get in touch on
  // WhatsApp instead, so we check the fit first. Set P8T.buy = true (snippet p8-strap-tryon) to bring Add to bag back.
  var BUY = C.buy === true;
  var W = 800, H = 1000, TILE = '#F5F4F2';

  var EN_S = {
    title: 'The Strap Room', yourWatch: 'Your watch', change: 'Change', strap: 'Strap', length: 'Length',
    mats: { Leather: 'Leather', Rubber: 'Rubber', Fabric: 'Fabric' }, material: 'Material',
    choose: 'Choose your watch', search: 'Brand, model or reference', searchLabel: 'Search for your watch',
    ours: 'Watches we sell', others: 'Other watches',
    nStraps: function (n) { return n === 1 ? '1 strap' : n + ' straps'; },
    nVersions: function (n) { return n + ' versions'; },
    versionDial: function (b, n) { return b + ' ' + n + ': version and dial'; },
    useWatch: 'Try straps on this watch',
    noResult: function (q) { return 'No watch we can fit yet for “' + q + '”.'; },
    askWa: 'Ask us on WhatsApp',
    waAskWatch: function (q) { return 'Hello PRJKT8, which strap would fit my ' + q + '?'; },
    inStock: 'In stock', outStock: 'Not in stock in this length',
    prev: 'Previous colour', next: 'Next colour',
    why: 'Why other straps don’t fit', alsoFit: 'Also fit, without a picture here:',
    colours: function (n) { return n === 1 ? '1 colour' : n + ' colours'; },
    seeStrap: 'See the strap', seeWatch: 'See the watch',
    added: 'Added to your bag', viewBag: 'View bag', keep: 'Keep trying',
    forYour: function (w) { return 'Your bag says “For your watch: ' + w + '”. We check the fit again before it ships.'; },
    propKey: 'For your watch',
    addToBag: 'Add to bag', adding: 'Adding…', notify: 'Notify me',
    betaNote: 'The Strap Room is still in beta. To make sure the strap fits your watch, please get in touch before you order.',
    fitAsk: 'Get in touch on WhatsApp',
    waFit: function (s, w) { return 'Hello PRJKT8, I would like the ' + s + ' for my ' + w + '. Could you check that it fits?'; },
    notifyHint: 'Not in stock in this length. Notify me opens WhatsApp with your strap and watch filled in.',
    waNotify: function (s, w) { return 'Hello PRJKT8, please let me know when the ' + s + ' is back in stock. It is for my ' + w + '.'; },
    madeFor: 'made for this model', sizeKey: function (k) { return k + ' size'; },
    mm: function (n) { return n + ' mm'; },
    taper: function (a, b) { return a + '–' + b + ' mm'; },
    longShort: function (a, b) { return 'Long end ' + a + ' mm, short end ' + b + ' mm.'; },
    error: 'Something went wrong. Please try again, or ask us on WhatsApp.',
    loading: 'Loading…', close: 'Close', watchPic: 'Your watch on the chosen strap',
    fit: {
      sfw: function (l) { return 'Takes ' + l + ' mm straps. Delugs confirms any of its ' + l + ' mm straps fits it.'; },
      maker: function (l) { return 'Takes ' + l + ' mm straps, from the maker’s own figure.'; },
      review: function (l) { return 'Takes ' + l + ' mm straps.'; },  /* archived pieces: width from a hands-on review + the photo, not the maker */
      curved: function (l) { return 'Short lugs: it takes curved-end straps, ' + l + ' mm.'; },
      curvedRubber: function (l) { return 'Short lugs: it takes curved rubber straps, ' + l + ' mm.'; },
      chunky: function (l) { return 'Wide ' + l + ' mm lugs: it takes Delugs’ chunky straps only.'; },
      tank: function (l) { return 'It takes straps made for the Tank (' + l + ' mm) only.'; },
      taper: function () { return 'It takes straps that taper from 20 to 18 mm, and Delugs’ Black Bay 58 rubber.'; },
      own: function () { return 'The case has its own fitting: it takes only straps made for this model.'; },
      sf: function (a, b) { return 'SEVENFRIDAY case with no lugs: the strap tucks under it. It takes SEVENFRIDAY’s own straps only, ' + a + ' mm at the case tapering to ' + b + ' mm.'; },
      count: function (n) { return n === 1 ? 'One strap we stock fits it.' : n + ' straps we stock fit it.'; },
      held: function (l) { return 'Our ' + l + ' may fit, but our listing doesn’t say which size it is for, so it isn’t shown.'; },
      conflict: 'Delugs has two pages for this reference that disagree; we follow the stricter one.',
      and: ' and '
    },
    why_: {
      other_model: function () { return 'Made for another model.'; },
      curved_not_listed: function () { return 'Curved ends are for short-lug watches; Delugs doesn’t list them for this one.'; },
      chunky_not_listed: function () { return 'Chunky straps are for wide-lug watches; Delugs doesn’t list them for this one.'; },
      not_in_width: function (n) { return 'We don’t stock this strap in ' + n + ' mm.'; },
      needs_curved_rubber: function () { return 'Delugs makes curved rubber straps for this watch’s short lugs.'; },
      needs_curved: function () { return 'Delugs makes curved straps for this watch’s short lugs.'; },
      listed_not_in_width: function (n) { return 'Delugs lists this strap for this watch, but we don’t stock it in ' + n + ' mm.'; },
      only_made_for: function () { return 'Delugs lists only straps made for this model.'; },
      several_sizes: function () { return 'Delugs makes this strap in several sizes and our listing doesn’t say which we stock.'; },
      only_taper: function () { return 'Delugs lists only straps that taper from 20 to 18 mm for this watch.'; },
      taper_unknown: function () { return 'Delugs lists its 20–18 mm taper version for this watch; our listing doesn’t say which taper we stock.'; },
      sf_only: function () { return 'Straps from other makers don’t fit SEVENFRIDAY cases.'; }
    },
    howTitle: 'How we decide what fits',
    rules: [
      ['Standard lugs', 'Delugs says any of its straps in the watch’s exact lug width fits. We offer our straight-end straps stocked in that width, nothing a millimetre off.'],
      ['Short or shaped lugs', 'Where Delugs lists curved, chunky or tapered straps for a watch, we offer only those, in that width.'],
      ['Cases with their own fitting', 'Santos, Overseas and others take straps made for that model. Only those are offered.'],
      ['Makers’ own straps', 'SEVENFRIDAY cases have no lugs: the strap tucks under the case. They take SEVENFRIDAY’s own straps only, in the width SEVENFRIDAY gives for each series.'],
      ['Only watches we can fit', 'A watch appears only when at least one strap we stock fits it. More watches follow as we check them.']
    ],
    credit: 'Strap pictures are the makers’ own (Delugs, SEVENFRIDAY). Most watch pictures are Delugs’.',
    dial: function (d) { return d; }, version: function (v) { return v; },
    start: { q: 'Which watch is it for?', sub: 'Pick your watch to see the straps that fit it.',
      subStrap: function (l) { return 'Pick your watch to see the ' + l + ' on it.'; },
      search: 'Search brand, model or reference', or: 'Or start with one of these', all: 'See all watches', example: 'Example' },
    hintSwipe: 'Swipe for more colours', hintArrows: 'Use the arrows for more colours',
    notFit: function (l, w) { return 'The ' + l + ' doesn’t fit your ' + w + '. These straps do.'; }
  };

  var AR_S = {
    title: 'ركن الأحزمة', yourWatch: 'ساعتك', change: 'تغيير', strap: 'الحزام', length: 'الطول',
    mats: { Leather: 'جلد', Rubber: 'مطاط', Fabric: 'قماش' }, material: 'الخامة',
    choose: 'اختر ساعتك', search: 'العلامة أو الطراز أو المرجع', searchLabel: 'ابحث عن ساعتك',
    ours: 'ساعات نبيعها', others: 'ساعات أخرى',
    nStraps: function (n) { return 'الأحزمة: ' + n; },
    nVersions: function (n) { return 'الإصدارات: ' + n; },
    versionDial: function (b, n) { return b + ' ' + n + ': الإصدار والمينا'; },
    useWatch: 'جرّب الأحزمة على هذه الساعة',
    noResult: function (q) { return 'لا توجد بعد ساعة نستطيع مطابقتها مع «' + q + '».'; },
    askWa: 'اسألنا عبر واتساب',
    waAskWatch: function (q) { return 'مرحباً PRJKT8، أي حزام يناسب ساعتي ' + q + '؟'; },
    inStock: 'متوفر', outStock: 'غير متوفر بهذا الطول',
    prev: 'اللون السابق', next: 'اللون التالي',
    why: 'لماذا لا تناسبها أحزمة أخرى', alsoFit: 'تناسبها أيضاً، دون صورة هنا:',
    colours: function (n) { return n === 1 ? 'لون واحد' : n === 2 ? 'لونان' : n <= 10 ? n + ' ألوان' : n + ' لوناً'; },
    seeStrap: 'صفحة الحزام', seeWatch: 'صفحة الساعة',
    added: 'أُضيف إلى حقيبتك', viewBag: 'عرض الحقيبة', keep: 'متابعة التجربة',
    forYour: function (w) { return 'سجّلنا في حقيبتك: «لساعتك: \u2068' + w + '\u2069». ونتحقق من الملاءمة مرة أخرى قبل الشحن.'; },
    propKey: 'لساعتك',
    addToBag: 'أضف إلى الحقيبة', adding: 'جارٍ الإضافة…', notify: 'أبلغني عند توفره',
    notifyHint: 'غير متوفر بهذا الطول. زر «أبلغني عند توفره» يفتح واتساب ومعه اسم الحزام والساعة.',
    waNotify: function (s, w) { return 'مرحباً PRJKT8، أرجو إبلاغي عند توفر ' + s + '. وهو لساعتي ' + w + '.'; },
    madeFor: 'مصنوع لهذا الطراز', sizeKey: function (k) { return 'مقاس ' + k; },
    mm: function (n) { return n + ' mm'; },
    taper: function (a, b) { return '\u2066' + a + '–' + b + ' mm\u2069'; },
    longShort: function (a, b) { return 'الطرف الطويل ' + a + ' mm، والطرف القصير ' + b + ' mm.'; },
    error: 'حدث خطأ. يُرجى المحاولة مرة أخرى، أو اسألنا عبر واتساب.',
    loading: 'جارٍ التحميل…', close: 'إغلاق', watchPic: 'ساعتك مع الحزام الذي اخترته',
    fit: {
      sfw: function (l) { return 'يناسبها حزام بعرض ' + l + ' mm. وتؤكد Delugs أن أي حزام لديها بهذا العرض يناسبها.'; },
      maker: function (l) { return 'يناسبها حزام بعرض ' + l + ' mm، وفق مواصفات الصانع.'; },
      curved: function (l) { return 'عرواتها قصيرة، فيناسبها حزام منحني الطرف بعرض ' + l + ' mm.'; },
      curvedRubber: function (l) { return 'عرواتها قصيرة، فيناسبها حزام مطاطي منحني الطرف بعرض ' + l + ' mm.'; },
      chunky: function (l) { return 'عرواتها عريضة (' + l + ' mm)، فلا تناسبها إلا أحزمة Delugs السميكة.'; },
      tank: function (l) { return 'لا يناسبها إلا حزام مصنوع لساعة Tank (' + l + ' mm).'; },
      taper: function () { return 'يناسبها حزام يضيق من 20 إلى 18 mm، وحزام Delugs المطاطي المخصص لساعة Black Bay 58.'; },
      own: function () { return 'للعلبة طريقة تثبيت خاصة، فلا يناسبها إلا حزام مصنوع لهذا الطراز.'; },
      sf: function (a, b) { return 'علبة SEVENFRIDAY بلا عروات، والحزام يُثبَّت تحتها. ولا يناسبها إلا أحزمة SEVENFRIDAY نفسها، بعرض ' + a + ' mm عند العلبة يضيق إلى ' + b + ' mm.'; },
      count: function (n) { return n === 1 ? 'يناسبها حزام واحد من أحزمتنا.' : 'عدد أحزمتنا التي تناسبها: ' + n + '.'; },
      held: function (l) { return 'قد يناسبها ' + l + ' لدينا، لكن صفحة المنتج لا تذكر المقاس المخصص له، لذا لا نعرضه.'; },
      conflict: 'لدى Delugs صفحتان لهذا المرجع لا تتفقان، ونتبع الأكثر تحفظاً.',
      and: ' و'
    },
    why_: {
      other_model: function () { return 'مصنوع لطراز آخر.'; },
      curved_not_listed: function () { return 'الأطراف المنحنية مخصصة للساعات ذات العروات القصيرة، ولا تدرجها Delugs لهذه الساعة.'; },
      chunky_not_listed: function () { return 'الأحزمة السميكة مخصصة للساعات ذات العروات العريضة، ولا تدرجها Delugs لهذه الساعة.'; },
      not_in_width: function (n) { return 'لا نوفر هذا الحزام بعرض ' + n + ' mm.'; },
      needs_curved_rubber: function () { return 'تصنع Delugs لهذه الساعة أحزمة مطاطية منحنية الطرف تناسب عرواتها القصيرة.'; },
      needs_curved: function () { return 'تصنع Delugs لهذه الساعة أحزمة منحنية الطرف تناسب عرواتها القصيرة.'; },
      listed_not_in_width: function (n) { return 'تدرج Delugs هذا الحزام لهذه الساعة، لكننا لا نوفره بعرض ' + n + ' mm.'; },
      only_made_for: function () { return 'تدرج Delugs فقط الأحزمة المصنوعة لهذا الطراز.'; },
      several_sizes: function () { return 'تصنع Delugs هذا الحزام بعدة مقاسات، وصفحة المنتج لدينا لا تذكر أيها نوفر.'; },
      only_taper: function () { return 'تدرج Delugs لهذه الساعة فقط الأحزمة التي تضيق من 20 إلى 18 mm.'; },
      taper_unknown: function () { return 'تدرج Delugs لهذه الساعة نسختها التي تضيق من 20 إلى 18 mm، وصفحة المنتج لدينا لا تذكر أي نسخة نوفر.'; },
      sf_only: function () { return 'أحزمة الصانعين الآخرين لا تناسب علب SEVENFRIDAY.'; }
    },
    howTitle: 'كيف نحدد ما يناسب ساعتك',
    rules: [
      ['العروات القياسية', 'تؤكد Delugs أن أي حزام لديها بعرض العروة نفسه تماماً يناسب الساعة. نعرض أحزمتنا ذات الأطراف المستقيمة المتوفرة بهذا العرض، دون أي فارق ولو بمليمتر.'],
      ['العروات القصيرة أو ذات الشكل الخاص', 'حين تدرج Delugs لساعة ما أحزمة منحنية الطرف أو سميكة أو متدرجة العرض، نعرض تلك الأحزمة وحدها، بالعرض نفسه.'],
      ['علب بطريقة تثبيت خاصة', 'ساعات مثل Santos وOverseas تتطلب أحزمة مصنوعة لطرازها، ولا نعرض سواها.'],
      ['أحزمة الصانع نفسه', 'علب SEVENFRIDAY بلا عروات، والحزام يُثبَّت تحت العلبة. ولا يناسبها إلا أحزمة SEVENFRIDAY نفسها، بالعرض الذي تحدده SEVENFRIDAY لكل سلسلة.'],
      ['ساعات نستطيع مطابقتها فقط', 'لا تظهر الساعة إلا إذا ناسبها حزام واحد على الأقل من أحزمتنا. ونضيف المزيد من الساعات كلما تحققنا منها.']
    ],
    credit: 'صور الأحزمة من صانعيها (Delugs وSEVENFRIDAY)، ومعظم صور الساعات من Delugs.',
    dial: function (d) {
      var M = { 'Brown dial': 'بني', 'Blue/Navy dial': 'أزرق/كحلي', 'Taupe dial': 'رمادي بني', 'Purple/Bordeaux dial': 'أرجواني/عنابي',
        'Green dial': 'أخضر', 'Red dial': 'أحمر', 'Black dial': 'أسود' };
      return M[d] ? 'المينا: ' + M[d] : d;
    },
    version: function (v) {
      var M = { 'Steel': 'فولاذ', '925 silver': 'فضة 925', 'Bronze': 'برونز', '18K gold': 'ذهب عيار 18', 'GMT': 'GMT', 'Steel, M7939A1A0': 'فولاذ، M7939A1A0' };
      return M[v] || v;
    },
    start: { q: 'لأي ساعة تريد الحزام؟', sub: 'اختر ساعتك لترى الأحزمة التي تناسبها.',
      subStrap: function (l) { return 'اختر ساعتك لترى ' + l + ' عليها.'; },
      search: 'ابحث بالعلامة أو الطراز أو المرجع', or: 'أو ابدأ بإحدى هذه الساعات', all: 'كل الساعات', example: 'مثال' },
    hintSwipe: 'اسحب لرؤية ألوان أخرى', hintArrows: 'استخدم الأسهم لرؤية ألوان أخرى',
    notFit: function (l, w) { return l + ' لا يناسب ساعتك \u2068' + w + '\u2069، لكن هذه الأحزمة تناسبها.'; }
  };
  /* Arabic: keep each "20 mm" together as one left-to-right unit inside the Arabic sentence */
  function isolate(t) { return typeof t === 'string' ? t.replace(/(\d+(?:\.\d+)?)\s?mm/g, '\u2066$1\u00a0mm\u2069') : t; }
  function wrapAll(o) {
    Object.keys(o).forEach(function (k) {
      var v = o[k];
      if (typeof v === 'function') o[k] = (function (f) { return function () { return isolate(f.apply(null, arguments)); }; })(v);
      else if (typeof v === 'string') o[k] = isolate(v);
      else if (v && typeof v === 'object' && !Array.isArray(v)) wrapAll(v);
    });
    return o;
  }
  var S = AR ? wrapAll(AR_S) : EN_S;

  /* ---------- helpers ---------- */
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var base = String(C.data || '').split('?')[0].replace(/[^\/]*$/, '');
  var asset = function (name) { return base + name + (C.build ? '?v=' + C.build : ''); };
  var rootPath = function (p) { return (C.root && C.root !== '/' ? C.root : '') + p; };
  var D = null, loadP = null;
  function load() {
    if (!loadP) loadP = fetch(C.data).then(function (r) { if (!r.ok) throw new Error('data ' + r.status); return r.json(); })
      .then(function (d) { D = d; return d; });
    return loadP;
  }
  var imgCache = {};
  function img(src) {
    if (!imgCache[src]) imgCache[src] = new Promise(function (res, rej) { var i = new Image(); i.decoding = 'async'; i.onload = function () { res(i); }; i.onerror = rej; i.src = src; });
    return imgCache[src];
  }
  var MATS = ['Leather', 'Rubber', 'Fabric'];
  function matOf(lineEn) { return /elastic loop|delcro|hook strap|canvas/i.test(lineEn) ? 'Fabric' : /cts|rubber|sailcloth|silicone|fkm/i.test(lineEn) ? 'Rubber' : 'Leather'; }
  function lineName(i) { var l = D.lines[i]; return AR ? l.ar : l.en; }
  function strapLine(s) { return lineName(s.l); }
  function strapColour(s) { return AR ? s.ca : s.c; }
  function watchLabel(w) { return w.brand + ' ' + w.name + (w.ref ? ' (' + w.ref + ')' : ''); }
  function joinAnd(list) { return list.length < 2 ? list.join('') : list.slice(0, -1).join(AR ? '، ' : ', ') + S.fit.and + list[list.length - 1]; }

  /* live prices and stock, read from the store when a strap line is first shown */
  var LIVE = {}, liveP = {};
  function live(handle) {
    if (!liveP[handle]) liveP[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (p) { p.variants.forEach(function (v) { LIVE[v.id] = { cents: v.price, ok: v.available, taxable: v.taxable !== false }; }); })
      .catch(function () {});
    return liveP[handle];
  }
  function priceOf(v) {
    var L = LIVE[v.id];
    var cents = L ? L.cents : Math.round(parseFloat(v.price) * 100);
    var taxable = L ? L.taxable : true;
    var rate = +C.vat || 0;
    return cents + (taxable && rate ? Math.round(cents * rate / 100) : 0);
  }
  function okOf(v) { var L = LIVE[v.id]; return L ? L.ok : v.ok; }
  function money(cents) {
    var t = (cents / 100).toFixed(3).split('.');
    t[0] = t[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '<span class="money conversion-bear-money">BHD&nbsp;' + t[0] + '.' + t[1] + '</span>';
  }
  function scanPrices(el) { if (window.p8PriceScan) { try { window.p8PriceScan(el); } catch (e) {} } }

  /* fit statement for a watch */
  function said(w) {
    var l = w.lug, F = S.fit, s;
    if (w.src === 'sf') s = F.sf(l, l - 4);  /* SEVENFRIDAY: 28 to 24 mm (M, P, PS), 26 to 22 mm (T), from its own listings */
    else if (w.src === 'maker') s = F.maker(l);
    else if (w.src === 'review') s = (F.review || EN_S.fit.review)(l);  /* Arabic paused 16 Oct: English line on /ar */
    else if (w.kind === 'sfw') s = F.sfw(l);
    else if (w.coll === 'curved-straps') s = F.curved(l);
    else if (w.coll === 'curved-rubber-cts') s = F.curvedRubber(l);
    else if (w.coll === 'chunky-straps') s = F.chunky(l);
    else if (w.coll === 'cartier-tank-straps') s = F.tank(l);
    else if (w.coll === '20-18mm-taper-straps') s = F.taper();
    else s = F.own();
    var more = [F.count(w.n)];
    if (w.held && w.held.length) more.push(F.held(joinAnd(w.held.map(lineName))));
    if (w.conflict) more.push(F.conflict);
    return s + ' ' + more.join(' ');
  }

  /* ---------- markup ---------- */
  function shell(mode) {
    return '<div class="p8t__grid">' +
      '<div class="p8t__stagecol">' +
        '<div class="p8t__stage" data-stagebox>' +
          '<canvas width="' + W + '" height="' + H + '" role="img" tabindex="0" data-stage aria-label="' + esc(S.watchPic) + '"></canvas>' +
          '<canvas class="p8t__xfade" width="' + W + '" height="' + H + '" data-xfade aria-hidden="true"></canvas>' +
          '<button class="p8t__step p8t__step--prev" type="button" data-prev aria-label="' + esc(S.prev) + '">' + (AR ? '›' : '‹') + '</button>' +
          '<button class="p8t__step p8t__step--next" type="button" data-next aria-label="' + esc(S.next) + '">' + (AR ? '‹' : '›') + '</button>' +
          '<p class="p8t__loading" data-loading>' + esc(S.loading) + '</p>' +
          '<span class="p8t__example" data-example hidden>' + esc(S.start.example) + '</span>' +
          '<p class="p8t__hintpill" data-hint hidden></p>' +
        '</div>' +
        '<div class="p8t__caption" data-caption aria-live="polite"></div>' +
      '</div>' +
      '<div class="p8t__panel">' +
        '<div class="p8t__start" data-start hidden></div>' +
        '<div class="p8t__wwrap"><p class="p8t__label"><span class="p8t__n">1</span>' + esc(S.yourWatch) + '</p><div class="p8t__watchrow" data-watchrow></div>' +
          '<p class="p8t__notfit" data-notfit hidden></p></div>' +
        '<p class="p8t__fit" data-fit></p>' +
        '<div class="p8t__strapwrap"><p class="p8t__label"><span class="p8t__n">2</span>' + esc(S.strap) + '</p>' +
          '<div class="p8t__chips" role="group" aria-label="' + esc(S.material) + '" data-mats></div>' +
          '<div class="p8t__lines" data-lines></div></div>' +
        '<div class="p8t__lengths" data-lengthbox><p class="p8t__label"><span class="p8t__n">3</span>' + esc(S.length) + '</p>' +
          '<div class="p8t__chips" role="group" aria-label="' + esc(S.length) + '" data-lengths></div><p class="p8t__hint" data-lenhint></p></div>' +
        '<div class="p8t__buybar" data-buybar><p class="p8t__hint p8t__betanote" data-betanote hidden></p><button class="p8-btn p8-btn--block p8t__buy" type="button" data-buy></button>' +
          '<div class="p8t__buymeta"><span class="p8t__vat" data-vat></span><a class="p8t__see" data-see href="#">' + esc(S.seeStrap) + '</a></div>' +
          '<p class="p8t__err" data-err hidden></p></div>' +
        '<details class="p8t__why" data-whybox><summary>' + esc(S.why) + '</summary><p class="p8t__nopic" data-nopic hidden></p><ul data-whylist></ul></details>' +
      '</div>' +
    '</div>' +
    (mode === 'page' ? '<section class="p8t__how"><h2 class="p8t__howtitle">' + esc(S.howTitle) + '</h2><ul class="p8t__rules">' +
      S.rules.map(function (r) { return '<li><b>' + esc(r[0]) + '</b><p>' + esc(r[1]) + '</p></li>'; }).join('') +
      '</ul><p class="p8t__credit">' + esc(S.credit) + '</p></section>' : '<p class="p8t__credit">' + esc(S.credit) + '</p>');
  }

  function pickerHtml() {
    return '<div class="p8t-d__head"><h2 class="p8t-d__title">' + esc(S.choose) + '</h2><button class="p8t-d__close" type="button" data-close aria-label="' + esc(S.close) + '">×</button></div>' +
      '<div class="p8t-d__body">' +
        '<input class="p8t__search" type="search" data-q placeholder="' + esc(S.search) + '" aria-label="' + esc(S.searchLabel) + '" autocomplete="off" enterkeyhint="search">' +
        '<div class="p8t__chips" role="group" data-tabs><button type="button" class="p8t__chip" data-tab="ours">' + esc(S.ours) + '</button><button type="button" class="p8t__chip" data-tab="others">' + esc(S.others) + '</button></div>' +
        '<div class="p8t__variants" data-variants hidden><p class="p8t__label" data-famname></p><div class="p8t__chips" data-vchips></div><div class="p8t__dials" data-dials></div><p class="p8t__dialname" data-dialname></p>' +
          '<button class="p8-btn p8-btn--block" type="button" data-use>' + esc(S.useWatch) + '</button></div>' +
        '<div class="p8t__wlist" data-wlist></div>' +
      '</div>';
  }

  /* ---------- one try-on (page or sheet) ---------- */
  function Tryon(root, mode, opts) {
    this.root = root; this.mode = mode; this.opts = opts || {};
    this.st = { w: null, s: null, mat: null, len: null, group: 'ours', q: '', e: null, v: 0, pick: null };
    this.ticket = 0;
  }
  Tryon.prototype.$ = function (sel) { return this.root.querySelector('[data-' + sel + ']'); };

  Tryon.prototype.start = function () {
    var self = this;
    this.root.classList.add('p8t');
    this.root.setAttribute('dir', AR ? 'rtl' : 'ltr');
    this.root.innerHTML = shell(this.mode);
    this.cv = this.$('stage'); this.ctx = this.cv.getContext('2d');
    this.off = document.createElement('canvas'); this.off.width = W; this.off.height = H; this.octx = this.off.getContext('2d');
    return load().then(function () {
      self.byIdx(); self.pickStart(); self.bind(); self.renderWatch();
      if (self.starting) self.showStart(); else { self.draw(); self.hint(); }
    })
      .catch(function () { self.$('loading').textContent = S.error; });
  };

  /* the visitor's own watch, remembered in this browser only (nothing is sent to us) */
  function remembered() {
    try { var id = localStorage.getItem('p8t.watch'); return id && D.watches[id] && D.watches[id].fits.length ? id : null; } catch (e) { return null; }
  }
  function remember(id) {
    var w = D.watches[id];
    try { localStorage.setItem('p8t.watch', id); localStorage.setItem('p8t.watchName', w.name.length <= 28 ? w.name : w.brand); } catch (e) {}
  }
  var ENTRY = null;
  Tryon.prototype.byIdx = function () {
    this.W = D.watches;
    if (!ENTRY) {
      ENTRY = {};
      D.entries.forEach(function (e, i) { e.v.forEach(function (v) { v.refs.forEach(function (r) { if (!(r.id in ENTRY)) ENTRY[r.id] = i; }); }); });
    }
    this.entryOfWatch = ENTRY;
  };

  Tryon.prototype.pickStart = function () {
    var o = this.opts, st = this.st, Wt = this.W, self = this;
    var q = {};
    try { new URLSearchParams(location.search).forEach(function (v, k) { q[k] = v; }); } catch (e) {}
    var wid = null, sidx = null;
    if (o.watchHandle) {
      D.entries.some(function (e) { if (e.handle === o.watchHandle) { wid = e.v[0].refs[0].id; return true; } return false; });
    }
    if (!wid && this.mode === 'page' && q.w && Wt[q.w]) wid = q.w;
    if (this.mode === 'page' && q.s) D.straps.some(function (s, i) { if (s.id === q.s) { sidx = i; return true; } return false; });
    var mine = remembered();
    if (o.strapHandle) {
      var vid = +o.variant || 0;
      D.straps.some(function (s, i) {
        if (D.lines[s.l].h !== o.strapHandle) return false;
        var hasV = vid && Object.keys(s.var).some(function (k) { return s.var[k].some(function (v) { return v.id === vid; }); });
        if (hasV) { sidx = i; return true; }
        if (sidx === null) sidx = i;
        return false;
      });
    }
    var order = D.entries.map(function (e) { return e.v[0].refs[0].id; });
    var fav = Object.keys(Wt).filter(function (k) { return /terracotta/i.test(Wt[k].name); })[0];
    if (fav) order.unshift(fav);
    this.wantLine = o.strapHandle && sidx !== null ? D.straps[sidx].l : null;
    this.wantExact = o.strapHandle ? sidx : null;
    if (!wid && sidx !== null) {
      // a strap page: show the chosen colour on one of our watches if it fits one, else another colour of the
      // same strap on one of ours, and only then a watch from another maker
      var line = D.straps[sidx].l, exact = sidx;
      var ours = order.filter(function (id) { return id === fav || (D.entries[ENTRY[id]] || {}).g === 'ours'; });
      var rest = order.filter(function (id) { return ours.indexOf(id) < 0; });
      var sameLine = function (id) { return Wt[id].fits.filter(function (i) { return D.straps[i].l === line; })[0]; };
      [[ours, true], [ours, false], [rest, true], [rest, false]].some(function (p) {
        var hit = p[0].filter(function (id) { return p[1] ? Wt[id].fits.indexOf(exact) > -1 : sameLine(id) !== undefined; })[0];
        if (hit) { wid = hit; sidx = p[1] ? exact : sameLine(hit); }
        return !!hit;
      });
    }
    if (!wid) wid = fav || order[0];
    // a visitor's own watch comes first; with none yet, the page and strap pages start with "Which watch is it for?"
    this.starting = false; this.notFit = null;
    if (!o.watchHandle && !(this.mode === 'page' && q.w && Wt[q.w])) {
      if (mine && (this.mode === 'page' || this.wantLine !== null)) { wid = mine; sidx = this.fitFor(mine); }
      else if (this.mode === 'page' || this.wantLine !== null) this.starting = true;
    }
    st.w = wid;
    var w = Wt[wid];
    st.s = sidx !== null && w.fits.indexOf(sidx) > -1 ? sidx : firstStrap(w);
    st.mat = matOf(D.lines[D.straps[st.s].l].en);
    if (this.mode === 'page' && !this.starting) this.syncUrl();
  };
  // the strap from a strap page on this watch: the same colour if it fits, else another colour of that strap;
  // if no colour of it fits, the watch's own first strap and a note saying so
  Tryon.prototype.fitFor = function (wid) {
    var w = this.W[wid], line = this.wantLine;
    this.notFit = null;
    if (line === null || line === undefined) return null;
    if (this.wantExact !== null && w.fits.indexOf(this.wantExact) > -1) return this.wantExact;
    var same = w.fits.filter(function (i) { return D.straps[i].l === line; })[0];
    if (same !== undefined) return same;
    this.notFit = line;
    return null;
  };

  /* ---------- the first screen: which watch is it for? ---------- */
  // the usual tiles; on a strap page whose strap fits none of them (a SEVENFRIDAY strap), the watches it does fit
  Tryon.prototype.startTiles = function (line) {
    var self = this, base = D.start || [];
    if (line === null || line === undefined) return base;
    var fitsLine = function (i) {
      return D.entries[i].v.some(function (v) { return v.refs.some(function (r) {
        var w = self.W[r.id]; return w && w.fits.some(function (k) { return D.straps[k].l === line; }); }); });
    };
    if (base.some(fitsLine)) return base;
    return D.entries.map(function (e, i) { return i; }).filter(fitsLine).slice(0, 9);
  };
  Tryon.prototype.showStart = function () {
    var self = this, box = this.$('start');
    var line = this.wantLine;
    var tile = function (i) {
      var e = D.entries[i], first = e.v[0].refs[0].id, w = self.W[first];
      return '<button class="p8t__tile" type="button" data-e="' + i + '">' + photo(first, 'p8t__photo--tile') +
        '<span class="p8t__tname"><small>' + esc(e.brand || w.brand) + '</small>' + esc(e.k === 'family' ? e.name : (e.name || w.name)) + '</span></button>';
    };
    box.innerHTML = '<p class="p8t__label"><span class="p8t__n">1</span>' + esc(S.yourWatch) + '</p>' +
      '<h2 class="p8t__q">' + esc(S.start.q) + '</h2>' +
      '<p class="p8t__sub">' + esc(line !== null && line !== undefined ? S.start.subStrap(lineName(line)) : S.start.sub) + '</p>' +
      '<button class="p8t__searchbtn" type="button" data-startsearch><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M15.5 15.5 21 21" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>' + esc(S.start.search) + '</button>' +
      '<p class="p8t__or">' + esc(S.start.or) + '</p>' +
      '<div class="p8t__tiles">' + this.startTiles(line).map(tile).join('') + '</div>' +
      '<button class="p8t__all" type="button" data-startall>' + esc(S.start.all) + '</button>';
    box.hidden = false;
    this.root.classList.add('p8t--start');
    this.$('example').hidden = false;
    box.querySelector('[data-startsearch]').onclick = function () { self.openPicker(true); };
    box.querySelector('[data-startall]').onclick = function () { self.openPicker(); };
    box.querySelectorAll('.p8t__tile').forEach(function (b) {
      b.onclick = function () {
        var i = +b.getAttribute('data-e');
        if (D.entries[i].k === 'family') { self.openPicker(); self.chooseEntry(i); } else self.useWatch(D.entries[i].v[0].refs[0].id);
      };
    });
    this.demo();
  };
  // behind the question, an example watch changing strap slowly: each look holds ~5 s, then the next one dissolves in
  // over the top of it (a second canvas), so the picture never empties. Two straps per watch, then the next watch.
  // On a strap page: that strap's colours on the example watch. Nothing moves for visitors who ask for less motion.
  var HOLD = 5000, DISSOLVE = 1800;
  Tryon.prototype.demo = function () {
    var self = this, st = this.st, pairs;
    if (this.wantLine !== null && this.wantLine !== undefined) {
      var w0 = st.w, line = this.wantLine;
      pairs = this.W[w0].fits.filter(function (i) { return D.straps[i].l === line; }).map(function (i) { return [w0, i]; });
      if (this.wantExact !== null) pairs.sort(function (a, b) { return (b[1] === self.wantExact) - (a[1] === self.wantExact); });
    } else pairs = (D.demo || []).filter(function (p) { return self.W[p[0]]; });
    if (!pairs.length) pairs = [[st.w, st.s]];
    var k = 0;
    st.w = pairs[0][0]; st.s = pairs[0][1];
    this.draw();
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (pairs.length < 2 || still) return;
    var xc = this.$('xfade'), xctx = xc.getContext('2d');
    var xo = document.createElement('canvas'); xo.width = W; xo.height = H;
    var next = function () {
      if (!self.starting) return;
      if (document.hidden) { self.demoTimer = setTimeout(next, HOLD); return; }
      var n = (k + 1) % pairs.length, w = self.W[pairs[n][0]], s = D.straps[pairs[n][1]];
      Promise.all([img(asset(w.img)), img(asset(s.img))]).then(function (r) {
        if (!self.starting) return;
        paint(xctx, xo.getContext('2d'), W, H, w, s, r[0], r[1]);
        xc.classList.add('is-in');
        self.demoTimer = setTimeout(function () {
          if (!self.starting) return;
          k = n; st.w = pairs[k][0]; st.s = pairs[k][1];
          self.ctx.drawImage(xc, 0, 0);  // the new look is now underneath too, so the top layer can go without a flicker
          xc.classList.remove('is-in');
          self.demoTimer = setTimeout(next, HOLD);
        }, DISSOLVE + 80);
      }).catch(function () { self.demoTimer = setTimeout(next, HOLD); });
    };
    this.demoTimer = setTimeout(next, HOLD);
  };
  Tryon.prototype.leaveStart = function () {
    if (!this.starting) return;
    this.starting = false;
    clearTimeout(this.demoTimer);
    this.$('xfade').classList.remove('is-in');
    this.root.classList.remove('p8t--start');
    this.$('start').hidden = true;
    this.$('example').hidden = true;
  };
  // a one-time hint on the picture
  Tryon.prototype.hint = function () {
    var self = this, el = this.$('hint');
    try { if (localStorage.getItem('p8t.hinted')) return; localStorage.setItem('p8t.hinted', '1'); } catch (e) { return; }
    if (this.visible().length < 2) return;
    var touch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    el.textContent = touch ? S.hintSwipe : S.hintArrows;
    el.hidden = false;
    this.hintTimer = setTimeout(function () { self.unhint(); }, 6000);
  };
  Tryon.prototype.unhint = function () { var el = this.$('hint'); if (el) el.hidden = true; clearTimeout(this.hintTimer); };

  Tryon.prototype.syncUrl = function () {
    if (this.mode !== 'page' || !window.history || !history.replaceState) return;
    try {
      var u = new URL(location.href);
      u.searchParams.set('w', this.st.w);
      u.searchParams.set('s', D.straps[this.st.s].id);
      history.replaceState(null, '', u);
    } catch (e) {}
  };

  Tryon.prototype.bind = function () {
    var self = this;
    this.$('prev').onclick = function () { self.step(-1); };
    this.$('next').onclick = function () { self.step(1); };
    this.cv.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') self.step(AR ? 1 : -1);
      if (e.key === 'ArrowRight') self.step(AR ? -1 : 1);
    });
    var sx = null, sy = null, box = this.$('stagebox');
    box.addEventListener('pointerdown', function (e) { if (e.target.closest('.p8t__step')) return; sx = e.clientX; sy = e.clientY; });
    box.addEventListener('pointerup', function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy; sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) self.step((dx < 0) !== AR ? 1 : -1);
    });
    box.addEventListener('pointercancel', function () { sx = null; });
    this.$('buy').onclick = function () { self.buy(); };
  };

  /* ---------- drawing ---------- */
  Tryon.prototype.draw = function () {
    var self = this, t = ++this.ticket, w = this.W[this.st.w], s = this.st.s != null ? D.straps[this.st.s] : null;
    var jobs = [img(asset(w.img))];
    if (s) jobs.push(img(asset(s.img)));
    return Promise.all(jobs).then(function (r) {
      if (t !== self.ticket) return;
      self.$('loading').hidden = true;
      paint(self.ctx, self.octx, W, H, w, s, r[0], r[1]);
    }).catch(function () { self.$('loading').hidden = false; self.$('loading').textContent = S.error; });
  };
  function paint(c, octx, CW, CH, w, s, head, sheet) {
    var sc = CW / W, g = w.geo, ox = W / 2 - g.top.cx, oy = H / 2 - g.h / 2;
    c.save(); c.setTransform(1, 0, 0, 1, 0, 0); c.scale(sc, sc);
    c.clearRect(0, 0, W, H); c.fillStyle = TILE; c.fillRect(0, 0, W, H);
    if (s && sheet) {
      octx.clearRect(0, 0, W, H);
      [['top', s.t], ['bottom', s.b]].forEach(function (p) {
        var side = p[0], sg = p[1], k = g[side].gap / sg.width;
        var reach = side === 'top' ? (sg.end - sg.knob) * k : (sg.knob - sg.end) * k;
        var ey = side === 'top' ? oy + g.top.case + 0.5 * reach : oy + g.bottom.case - 0.5 * reach;
        octx.drawImage(sheet, 0, sg.y0 || 0, sg.w, sg.h, ox + g[side].cx - sg.cx * k, ey - sg.end * k, sg.w * k, sg.h * k);
      });
      c.save(); c.shadowColor = 'rgba(38,30,24,0.18)'; c.shadowBlur = 14; c.shadowOffsetY = 4; c.drawImage(octx.canvas, 0, 0); c.restore();
    }
    c.save(); c.shadowColor = 'rgba(20,20,20,0.30)'; c.shadowBlur = 22; c.shadowOffsetY = 8; c.drawImage(head, ox, oy); c.restore();
    c.restore();
  }

  /* ---------- the watch row, fit line, straps ---------- */
  /* the watch in a square tile: our own listing photo for watches we sell, Delugs' picture for other makers */
  function photo(wid, cls) {
    var e = D.entries[ENTRY[wid]] || {}, w = D.watches[wid];
    var src = e.img ? e.img + (e.img.indexOf('?') > -1 ? '&' : '?') + 'width=240' : (w.th ? asset(w.th) : asset(w.img));
    return '<span class="p8t__photo ' + (cls || '') + (e.img ? ' p8t__photo--ours' : '') + '"><img alt="" loading="lazy" decoding="async" src="' + esc(src) + '"></span>';
  }
  // the first strap to show on a watch: one made for that model if we have it (Submariner, Speedmaster, Santos…), else a Chevre
  function firstStrap(w) {
    var words = (w.brand + ' ' + w.name).toLowerCase().split(/[^a-z0-9]+/).filter(function (x) { return x.length > 3; });
    var made = w.fits.filter(function (i) { var l = D.lines[D.straps[i].l].en.toLowerCase(); return / for /.test(l) && words.some(function (x) { return l.indexOf(x) > -1; }); })[0];
    if (made !== undefined) return made;
    var chevre = w.fits.filter(function (i) { return /chevre/i.test(D.lines[D.straps[i].l].en); })[0];
    return chevre !== undefined ? chevre : w.fits[0];
  }
  Tryon.prototype.visible = function () {
    var st = this.st;
    return this.W[st.w].fits.filter(function (i) { return matOf(D.lines[D.straps[i].l].en) === st.mat; });
  };
  Tryon.prototype.renderWatch = function () {
    var self = this, st = this.st, w = this.W[st.w];
    var e = D.entries[this.entryOfWatch[st.w]] || {};
    var link = this.mode === 'page' && e.handle ? '<a class="p8t__wlink" href="' + esc(rootPath('/products/' + e.handle)) + '">' + esc(S.seeWatch) + '</a>' : '';
    this.$('watchrow').innerHTML = photo(st.w, 'p8t__photo--row') +
      '<div class="p8t__wtext"><small>' + esc(w.brand) + '</small><span class="p8t__wname">' + esc(w.name) + '</span>' +
      (w.ref ? '<span class="p8t__wref"><bdi dir="ltr">' + esc(w.ref) + '</bdi></span>' : '') + link + '</div>' +
      '<button class="p8t__change" type="button" data-change>' + esc(S.change) + '</button>';
    this.$('change').onclick = function () { self.openPicker(); };
    var nf = this.$('notfit');
    nf.hidden = this.notFit === null || this.notFit === undefined;
    nf.textContent = nf.hidden ? '' : S.notFit(lineName(this.notFit), w.brand + ' ' + w.name);
    this.$('fit').textContent = said(w);
    var mats = MATS.filter(function (m) { return w.fits.some(function (i) { return matOf(D.lines[D.straps[i].l].en) === m; }); });
    if (mats.indexOf(st.mat) < 0) st.mat = st.s != null && w.fits.indexOf(st.s) > -1 ? matOf(D.lines[D.straps[st.s].l].en) : mats[0];
    this.$('mats').innerHTML = mats.length > 1 ? mats.map(function (m) {
      return '<button type="button" class="p8t__chip" data-m="' + m + '" aria-pressed="' + (m === st.mat) + '">' + esc(S.mats[m]) + '</button>';
    }).join('') : '';
    this.$('mats').hidden = mats.length < 2;
    this.$('mats').querySelectorAll('button').forEach(function (b) {
      b.onclick = function () { st.mat = b.getAttribute('data-m'); var first = self.visible()[0]; if (first != null) { st.s = first; st.len = null; } self.renderWatch(); self.draw(); self.syncUrl(); };
    });
    var groups = [], byLine = {};
    this.visible().forEach(function (i) { var l = D.straps[i].l; if (!(l in byLine)) { byLine[l] = []; groups.push(l); } byLine[l].push(i); });
    this.$('lines').innerHTML = groups.map(function (l) {
      return '<div class="p8t__line"><p class="p8t__lname">' + esc(lineName(l)) + '</p><div class="p8t__swatches">' + byLine[l].map(function (i) {
        var s = D.straps[i];
        return '<button class="p8t__sw" type="button" data-i="' + i + '" style="background:' + s.sw + '" title="' + esc(strapColour(s)) + '" aria-label="' + esc(strapLine(s) + ', ' + strapColour(s)) + '" aria-pressed="' + (i === st.s) + '"></button>';
      }).join('') + '</div></div>';
    }).join('');
    this.$('lines').querySelectorAll('.p8t__sw').forEach(function (b) { b.onclick = function () { self.pickStrap(+b.getAttribute('data-i')); }; });
    var np = w.noPic.filter(function (p) { return matOf(D.lines[p[0]].en) === st.mat; });
    var nopic = this.$('nopic');
    nopic.hidden = !np.length;
    nopic.textContent = np.length ? S.alsoFit + ' ' + np.map(function (p) { return lineName(p[0]) + ' (' + S.colours(p[1]) + ')'; }).join(AR ? '، ' : ', ') + (AR ? '.' : '.') : '';
    this.$('whylist').innerHTML = w.no.map(function (r) {
      var f = S.why_[r.c];
      return '<li>' + esc(f ? f(r.n) : r.c) + ' <span>' + esc(r.l.map(lineName).join(AR ? '، ' : ', ')) + '</span></li>';
    }).join('');
    this.$('whybox').hidden = !w.no.length && !np.length;
    this.renderPicked();
  };

  Tryon.prototype.pickStrap = function (i) {
    var st = this.st;
    st.s = i; st.len = null;
    this.root.querySelectorAll('.p8t__sw').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-i') === i)); });
    this.renderPicked(); this.draw(); this.syncUrl();
  };
  Tryon.prototype.step = function (d) {
    if (this.starting) return;
    this.unhint();
    var list = this.visible(); if (!list.length) return;
    var i = Math.max(0, list.indexOf(this.st.s));
    this.pickStrap(list[(i + d + list.length) % list.length]);
    var b = this.root.querySelector('.p8t__sw[aria-pressed="true"]');
    if (b && b.scrollIntoView) b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  };

  Tryon.prototype.keyFor = function (s, w) {
    if (s.var[String(w.lug)]) return String(w.lug);
    var k = Object.keys(s.var).filter(function (k) { return /^[A-Z]/.test(k) && w.name.toLowerCase().indexOf(k.toLowerCase()) > -1; })[0];
    return k || (s.var['-'] ? '-' : null);
  };
  Tryon.prototype.chosen = function (s, w) {
    var st = this.st, key = this.keyFor(s, w), list = (key && s.var[key]) || [];
    var withLen = list.filter(function (v) { return v.length; });
    if (!withLen.length) return { key: key, v: list[0] || null, withLen: withLen };
    if (!st.len || !withLen.some(function (v) { return v.length === st.len; })) { var f = withLen.filter(okOf)[0] || withLen[0]; st.len = f.length; }
    return { key: key, v: withLen.filter(function (v) { return v.length === st.len; })[0], withLen: withLen };
  };
  function widthText(key, w) {
    if (w && w.src === 'sf') return S.taper(w.lug, w.lug - 4);
    if (key && /^\d/.test(key)) return S.mm(key);
    if (key && key !== '-') return S.sizeKey(key);
    return w && w.kind === 'sfw' ? S.mm(w.lug) : S.madeFor;  // one width only (e.g. the Hook strap, 20 mm) on standard lugs
  }
  function shortLen(l) { return String(l).replace(/\s*\(.*\)/, ''); }

  Tryon.prototype.renderPicked = function () {
    var self = this, st = this.st, w = this.W[st.w], s = D.straps[st.s];
    if (!s) return;
    var handle = D.lines[s.l].h;
    if (handle && !liveP[handle]) live(handle).then(function () { if (D.straps[self.st.s] === s) self.renderPicked(); });
    var c = this.chosen(s, w), v = c.v, ok = v && okOf(v);
    this.$('caption').innerHTML = '<b>' + esc(strapLine(s)) + '</b><span>' + esc(strapColour(s)) + ' · ' + esc(S.mats[matOf(D.lines[s.l].en)]) + ' · ' + esc(widthText(c.key, w)) + ' · ' +
      (ok ? esc(S.inStock) : '<span class="p8t__out">' + esc(S.outStock) + '</span>') + '</span>';
    this.$('lengthbox').hidden = !c.withLen.length;
    this.$('lengths').innerHTML = c.withLen.map(function (x) {
      return '<button type="button" class="p8t__chip" data-len="' + esc(x.length) + '" aria-pressed="' + (x.length === st.len) + '"' + (okOf(x) ? '' : ' data-out') + '>' + esc(shortLen(x.length)) + '</button>';
    }).join('');
    this.$('lengths').querySelectorAll('button').forEach(function (b) { b.onclick = function () { st.len = b.getAttribute('data-len'); self.renderPicked(); }; });
    var m = v && v.length && String(v.length).match(/\((\d+)\/(\d+)\)/);
    this.$('lenhint').textContent = (m ? S.longShort(m[1], m[2]) : '') + (v && !ok ? (m ? ' ' : '') + S.notifyHint : '');
    var buy = this.$('buy'), ask = !BUY && ok;
    buy.disabled = !v;
    buy.innerHTML = ask ? esc(S.fitAsk || EN_S.fitAsk) : ok ? esc(S.addToBag) + ' <span class="p8t__dot">·</span> ' + money(priceOf(v)) : esc(S.notify);
    buy.classList.toggle('p8-btn--outline', !ok);
    var note = this.$('betanote');
    note.textContent = S.betaNote || EN_S.betaNote;
    note.hidden = BUY || !v;
    this.$('vat').innerHTML = ask ? money(priceOf(v)) + (C.vatLine ? ' <span class="p8t__dot">·</span> ' + esc(C.vatLine) : '') : ok && C.vat !== undefined ? (C.vatLine || '') : '';
    var see = this.$('see');
    see.href = rootPath('/products/' + (handle || '')) + (v ? '?variant=' + v.id : '');
    see.hidden = !handle;
    this.$('err').hidden = true;
    scanPrices(this.root);
  };

  /* ---------- Add to bag / Notify me ---------- */
  Tryon.prototype.buy = function () {
    var self = this, st = this.st, w = this.W[st.w], s = D.straps[st.s], c = this.chosen(s, w), v = c.v;
    if (!v) return;
    if (!BUY && okOf(v)) {
      var want = strapLine(s) + (AR ? '، ' : ', ') + strapColour(s) + (AR ? '، ' : ', ') + widthText(c.key, w) + (v.length ? (AR ? '، ' : ', ') + shortLen(v.length) : '');
      window.open('https://wa.me/' + (C.wa || '97366777600') + '?text=' + encodeURIComponent((S.waFit || EN_S.waFit)(want, watchLabel(w))), '_blank', 'noopener');
      return;
    }
    if (!okOf(v)) {
      var what = strapLine(s) + (AR ? '، ' : ', ') + strapColour(s) + (AR ? '، ' : ', ') + widthText(c.key, w) + (v.length ? (AR ? '، ' : ', ') + shortLen(v.length) : '');
      window.open('https://wa.me/' + (C.wa || '97366777600') + '?text=' + encodeURIComponent(S.waNotify(what, watchLabel(w))), '_blank', 'noopener');
      return;
    }
    var btn = this.$('buy');
    btn.disabled = true; btn.textContent = S.adding;
    var props = {}; props[S.propKey] = watchLabel(w);
    fetch((C.cartAdd || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return fetch((C.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return null; }); })
      .then(function (cart) { if (cart) bagCount(cart.item_count); btn.disabled = false; self.renderPicked(); self.showAdded(w, s, c.key, v); })
      .catch(function () { btn.disabled = false; self.renderPicked(); var e = self.$('err'); e.textContent = S.error; e.hidden = false; });
  };
  function bagCount(n) {
    var links = document.querySelectorAll('a.p8-iconlink[href="' + (C.cartUrl || '/cart') + '"]');
    links.forEach(function (a) {
      var b = a.querySelector('.p8-bagcount');
      if (!b && n > 0) { b = document.createElement('span'); b.className = 'p8-bagcount'; a.appendChild(b); }
      if (b) { if (n > 0) b.textContent = n; else b.remove(); }
    });
  }
  Tryon.prototype.showAdded = function (w, s, key, v) {
    var self = this, d = dialog('added', 'p8t-d--small');
    d.innerHTML = '<div class="p8t-d__head"><h2 class="p8t-d__title">' + esc(S.added) + '</h2><button class="p8t-d__close" type="button" data-close aria-label="' + esc(S.close) + '">×</button></div>' +
      '<div class="p8t-d__body p8t__added"><div class="p8t__item"><canvas width="160" height="200" data-mini></canvas><div><b>' + esc(strapLine(s)) + '</b><span>' +
      esc(strapColour(s)) + ' · ' + esc(widthText(key, w)) + (v.length ? ' · ' + esc(shortLen(v.length)) : '') + ' · ' + money(priceOf(v)) + '</span></div></div>' +
      '<p class="p8t__for">' + esc(S.forYour(watchLabel(w))) + '</p>' +
      '<div class="p8t__row"><a class="p8-btn" href="' + esc(C.cartUrl || '/cart') + '">' + esc(S.viewBag) + '</a><button class="p8-btn p8-btn--outline" type="button" data-keep>' + esc(S.keep) + '</button></div></div>';
    var mini = d.querySelector('[data-mini]'), mo = document.createElement('canvas'); mo.width = W; mo.height = H;
    Promise.all([img(asset(w.img)), img(asset(s.img))]).then(function (r) { paint(mini.getContext('2d'), mo.getContext('2d'), 160, 200, w, s, r[0], r[1]); });
    d.querySelector('[data-keep]').onclick = function () { d.close(); };
    d.querySelector('[data-close]').onclick = function () { d.close(); };
    scanPrices(d);
    d.showModal();
  };

  /* ---------- the watch picker ---------- */
  Tryon.prototype.openPicker = function (focus) {
    var self = this, st = this.st, d = dialog('picker', 'p8t-d--picker');
    d.innerHTML = pickerHtml();
    this.pk = d;
    var $p = function (s) { return d.querySelector('[data-' + s + ']'); };
    st.q = ''; st.group = (D.entries[this.entryOfWatch[st.w]] || {}).g || 'ours';
    $p('close').onclick = function () { d.close(); };
    $p('q').addEventListener('input', function (ev) { st.q = ev.target.value.trim(); $p('variants').hidden = true; self.renderList(); });
    d.querySelectorAll('[data-tab]').forEach(function (b) { b.onclick = function () { st.q = ''; $p('q').value = ''; st.group = b.getAttribute('data-tab'); $p('variants').hidden = true; self.renderList(); }; });
    $p('use').onclick = function () { self.useWatch(st.pick); };
    this.renderList();
    d.showModal();
    if (focus) $p('q').focus();  // in the same tap, so phones open the keyboard
    else if (window.matchMedia && window.matchMedia('(min-width: 900px)').matches) setTimeout(function () { $p('q').focus(); }, 50);
  };
  function entryLabel(e, Wt) {
    var first = Wt[e.v[0].refs[0].id];
    if (e.k === 'family') return { brand: e.brand, name: e.name, ref: '', w: first, img: null, ct: S.nVersions(e.v.length) };
    return { brand: e.brand || first.brand, name: e.name || first.name, ref: e.ref || first.ref, w: first, img: e.img, ct: S.nStraps(first.n) };
  }
  Tryon.prototype.rowHtml = function (e, i) {
    var st = this.st, l = entryLabel(e, this.W);
    var here = e.v.some(function (v) { return v.refs.some(function (r) { return r.id === st.w; }); });
    var pic = photo(e.v[0].refs[0].id, 'p8t__photo--list');
    return '<button class="p8t__wbtn" type="button" data-e="' + i + '" aria-pressed="' + here + '">' + pic +
      '<span class="p8t__nm"><small>' + esc(l.brand) + '</small>' + esc(l.name) + (l.ref ? ' <small><bdi dir="ltr">' + esc(l.ref) + '</bdi></small>' : '') + '</span>' +
      '<span class="p8t__ct">' + esc(l.ct) + '</span></button>';
  };
  Tryon.prototype.renderList = function () {
    var self = this, st = this.st, d = this.pk, box = d.querySelector('[data-wlist]');
    d.querySelectorAll('[data-tab]').forEach(function (b) { b.setAttribute('aria-pressed', String(!st.q && b.getAttribute('data-tab') === st.group)); });
    if (st.q) {
      var words = st.q.toLowerCase().split(/\s+/).filter(Boolean);
      var hits = [];
      D.entries.forEach(function (e, i) { if (words.every(function (w) { return e.q.indexOf(w) > -1; })) hits.push([e, i]); });
      var part = function (g) { return hits.filter(function (h) { return h[0].g === g; }); };
      var html = '';
      ['ours', 'others'].forEach(function (g) {
        var p = part(g);
        if (p.length) html += '<p class="p8t__group">' + esc(g === 'ours' ? S.ours : S.others) + '</p>' + p.map(function (h) { return self.rowHtml(h[0], h[1]); }).join('');
      });
      if (!hits.length) html = '<div class="p8t__none"><p>' + esc(S.noResult(st.q)) + '</p><a class="p8-btn p8-btn--outline" target="_blank" rel="noopener" href="https://wa.me/' +
        esc(C.wa || '97366777600') + '?text=' + encodeURIComponent(S.waAskWatch(st.q)) + '">' + esc(S.askWa) + '</a></div>';
      box.innerHTML = html;
    } else {
      box.innerHTML = D.entries.map(function (e, i) { return e.g === st.group ? self.rowHtml(e, i) : ''; }).join('');
    }
    box.querySelectorAll('.p8t__wbtn').forEach(function (b) { b.onclick = function () { self.chooseEntry(+b.getAttribute('data-e')); }; });
  };
  Tryon.prototype.chooseEntry = function (i) {
    var e = D.entries[i], st = this.st;
    if (e.k !== 'family') { this.useWatch(e.v[0].refs[0].id); return; }
    st.e = i; st.v = 0; st.pick = e.v[0].refs[0].id;
    for (var a = 0; a < e.v.length; a++) for (var b = 0; b < e.v[a].refs.length; b++) if (e.v[a].refs[b].id === st.w) { st.v = a; st.pick = st.w; }
    this.renderVariants();
    var box = this.pk.querySelector('[data-variants]');
    if (box.scrollIntoView) box.scrollIntoView({ block: 'nearest' });
  };
  Tryon.prototype.renderVariants = function () {
    var self = this, st = this.st, d = this.pk, e = D.entries[st.e], Wt = this.W;
    var $p = function (s) { return d.querySelector('[data-' + s + ']'); };
    $p('variants').hidden = false;
    $p('famname').textContent = S.versionDial(e.brand, e.name);
    $p('vchips').innerHTML = e.v.map(function (v, i) { return '<button class="p8t__chip" type="button" data-v="' + i + '" aria-pressed="' + (i === st.v) + '">' + esc(S.version(v.name)) + '</button>'; }).join('');
    $p('vchips').querySelectorAll('button').forEach(function (b) { b.onclick = function () { st.v = +b.getAttribute('data-v'); st.pick = e.v[st.v].refs[0].id; self.renderVariants(); }; });
    var refs = e.v[st.v].refs;
    $p('dials').innerHTML = refs.map(function (r) {
      return '<button class="p8t__dbtn" type="button" data-id="' + esc(r.id) + '" aria-label="' + esc(S.dial(r.dial || '') + ', ' + Wt[r.id].ref) + '" aria-pressed="' + (r.id === st.pick) + '">' + photo(r.id, 'p8t__photo--dial') + '</button>';
    }).join('');
    $p('dials').querySelectorAll('button').forEach(function (b) { b.onclick = function () { st.pick = b.getAttribute('data-id'); self.renderVariants(); }; });
    var r = refs.filter(function (r) { return r.id === st.pick; })[0];
    $p('dialname').innerHTML = (r && r.dial ? esc(S.dial(r.dial)) + ' · ' : '') + '<bdi dir="ltr">' + esc(Wt[st.pick].ref) + '</bdi>';
  };
  Tryon.prototype.useWatch = function (id) {
    var st = this.st, w = this.W[id], wasStart = this.starting;
    st.w = id; st.len = null;
    remember(id);
    this.leaveStart();
    var want = this.fitFor(id);
    if (want !== null) st.s = want;
    else if (wasStart) st.s = firstStrap(w);  // the example on screen says nothing about this watch
    else if (w.fits.indexOf(st.s) < 0 || this.notFit !== null) {
      var cur = st.s != null ? D.straps[st.s] : null;
      var same = cur ? w.fits.filter(function (i) { return D.straps[i].l === cur.l; })[0] : undefined;
      st.s = same !== undefined && !wasStart ? same : firstStrap(w);
    }
    st.mat = null;
    if (this.pk && this.pk.open) this.pk.close();
    this.renderWatch(); this.draw(); this.syncUrl();
    if (wasStart) this.hint();
  };

  /* ---------- dialogs ---------- */
  var dialogs = {};
  function dialog(name, cls) {
    var d = dialogs[name];
    if (!d) {
      d = document.createElement('dialog');
      d.className = 'p8t-d ' + (cls || '');
      d.setAttribute('dir', AR ? 'rtl' : 'ltr');
      d.setAttribute('lang', AR ? 'ar' : 'en');
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
      document.body.appendChild(d);
      dialogs[name] = d;
    }
    return d;
  }

  /* ---------- the sheet over a watch or strap page ---------- */
  var sheetTry = null;
  function lock(on) { document.documentElement.classList.toggle('p8t-lock', on); }
  function open(opts) {
    var d = dialog('sheet', 'p8t-d--sheet');
    if (!d.firstChild || (opts && opts.fresh)) {
      d.innerHTML = '<div class="p8t-d__head"><h2 class="p8t-d__title">' + esc(S.title) + '</h2><button class="p8t-d__close" type="button" data-close aria-label="' + esc(S.close) + '">×</button></div><div class="p8t-d__body" data-sheetbody></div>';
      d.querySelector('[data-close]').onclick = function () { d.close(); };
      d.addEventListener('close', function () { lock(false); });
      sheetTry = new Tryon(d.querySelector('[data-sheetbody]'), 'sheet', opts);
      sheetTry.start();
    }
    lock(true);
    d.showModal();
    return sheetTry;
  }
  function mount(el, opts) { var t = new Tryon(el, 'page', opts); t.start(); return t; }

  window.P8Tryon = { open: open, mount: mount };
  document.querySelectorAll('[data-p8t-page]').forEach(function (el) { mount(el, {}); });
})();
